export function useWorkingDays(api: ReturnType<typeof useAxios>) {
  const getAllWorkingDays = async (data: any) =>
    await api.$get(
      `/workingdays?limit=${data.limit}&page=${data.page}&sort=${data.sort}&dir=${data.dir}&search=${encodeURIComponent(data.search)}&status=${data.status}`,
    );
  const createWorkingDays = async (data: any) => await api.$post(`/workingdays`, data);
  const updateWorkingDays = async (data: any) => await api.$post(`/workingdays/update`, data);
  const getWorkingDay = async (id: any, month = 0) => await api.$get(`/workingdays/${id}/${month}`);
  const getWorkingDayOfMonths = async (data: any) => await api.$get(`/workingdays/month/${data.year}/${data.month}`);
  const getHolidaysInMonth = async (data: any) => await api.$get(`/workingdays/holidaysinmonth/${data.year}/${data.month}`);
  const deleteHolidays = async (data: any) => await api.$delete(`/workingdays/deleteholidays/${data.date}`);

  return {
    getAllWorkingDays,
    createWorkingDays,
    getWorkingDay,
    updateWorkingDays,
    getWorkingDayOfMonths,
    getHolidaysInMonth,
    deleteHolidays,
  };
}
